// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ws-status-error {
  -webkit-animation: ws-traffic-error 0.4s ease-out 1 alternate;
  -moz-animation: ws-traffic-error 0.4s ease-out 1 alternate;
  animation: ws-traffic-error 0.4s ease-out 1 alternate;
}
@-moz-keyframes ws-traffic-error {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.6);
  }
}
@-webkit-keyframes ws-traffic-error {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.6);
  }
}
@keyframes ws-traffic-error {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.6);
  }
}
.ws-status-ok {
  background-color: transparent;
  border-radius: 100%;
  -webkit-animation: ws-traffic-ok 0.2s ease-out 1 alternate;
  -moz-animation: ws-traffic-ok 0.2s ease-out 1 alternate;
  animation: ws-traffic-ok 0.2s ease-out 1 alternate;
}
@-moz-keyframes ws-traffic-ok {
  0% {
    transform: scale(1);
    background-color: transparent;
    box-shadow: unset;
  }
  100% {
    transform: scale(1.2);
    background-color: green;
    box-shadow: 0 0 10px greenyellow;
  }
}
@-webkit-keyframes ws-traffic-ok {
  0% {
    transform: scale(1);
    background-color: transparent;
    box-shadow: unset;
  }
  100% {
    transform: scale(1.2);
    background-color: green;
    box-shadow: 0 0 10px greenyellow;
  }
}
@keyframes ws-traffic-ok {
  0% {
    transform: scale(1);
    background-color: transparent;
    box-shadow: unset;
  }
  100% {
    transform: scale(1.2);
    background-color: green;
    box-shadow: 0 0 10px greenyellow;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
